import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { setAttendeesToAdd } from '../../actions/calendar';
import { PlusSign } from '../shared/PlusSign';
import { PopOutIcon } from '../shared/PopOutIcon';
import ObjectIcon from '../shared/ObjectIcon';
import './SelectAttendee.scss';
import { Tooltip } from '../shared/Tooltip';

export const SelectAttendee = ({ details, disabled }) => {
  const { displayFields, objectApiName, objectId } = details;

  const dispatch = useDispatch();
  const selectedAttendees = useSelector((state) => state.calendar.attendeesToAdd);
  const toggleOn = !!selectedAttendees[objectId];
  const user = useSelector((state) => state.auth.user);
  const objectsAndDisplayFields = useSelector((state) => state.mail.settings?.calendarSettings?.attendeeDisplayFields);
  const currentDisplayFields = objectsAndDisplayFields?.find((object) => object.objectApiName === objectApiName)?.displayFields.map((field) => field.apiName) || [];
  const redirectLink = `${user.salesforceInstanceUrl}/lightning/r/${objectApiName}/${objectId}/view`;

  const handleToggle = () => {
    const newSelectedAttendees = { ...selectedAttendees };
    !toggleOn ? newSelectedAttendees[objectId] = details : delete newSelectedAttendees[objectId];
    dispatch(setAttendeesToAdd(newSelectedAttendees));
  };

  return (
    <div id={objectId}>
      <div className='select-attendee-card' disabled={disabled}>
        <ObjectIcon objectApiName={objectApiName} className='select-attendee-image' />
        <div className='select-attendee-details'>
          <Tooltip textContent={displayFields[currentDisplayFields[0]]}>
            <h2>{displayFields[currentDisplayFields[0]]}</h2>
          </Tooltip>
          { currentDisplayFields?.slice(1)?.map((currentDisplayField, index) => {
            return (
              <Tooltip textContent={displayFields[currentDisplayField]} key={index}>
                <p>{displayFields[currentDisplayField]}</p>
              </Tooltip>
            );
          }) }
        </div>
        <div className='select-attendee-iconsContainer'>
          <PopOutIcon
            link={redirectLink}
            className={`select-attendee-redirect`}
          />
          <PlusSign clickAction={handleToggle} selectedState={toggleOn} savedState={disabled} />
        </div>
      </div>
    </div>
  );
};

SelectAttendee.propTypes = {
  details: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

